const labels = {
	start: 'Launch E-Learning',
	confirmClosure: 'Are you sure you want to close this course? Your progress will not be saved.',
	passed: 'All done!',
};

const textDefaults = {
	'EN': {
		start: 'Start',
		confirmClosure: 'Are you sure you want to close this course? Your progress will not be saved.',
		passed: 'All done!',
	},
	FR: {
		start: 'Commencer',
		confirmClosure: 'Êtes-vous sûr de vouloir fermer ce cours? Votre progression ne sera pas enregistrée.',
		passed: 'Terminé!',
	},

	NL: {
		start: 'Starten',
		confirmClosure: 'Weet u zeker dat u deze cursus wilt sluiten? Uw voortgang wordt niet opgeslagen.',
		passed: 'Klaar!',
	},
	DE: {
		start: 'Starten',
		confirmClosure: 'Möchten Sie diesen Kurs wirklich schließen? Ihr Fortschritt wird nicht gespeichert.',
		passed: 'Fertig!',
	},
	PL: {
		start: 'Rozpocznij',
		confirmClosure: 'Czy na pewno chcesz zamknąć ten kurs? Twój postęp nie zostanie zapisany.',
		passed: 'Wszystko gotowe!',
	},
	BG: {
		start: 'Старт',
		confirmClosure: 'Сигурни ли сте, че искате да затворите този курс? Вашият прогрес няма да бъде запазен.',
		passed: 'Готово!',
	},
	CS: {
		start: 'Spustit',
		confirmClosure: 'Jste si jisti, že chcete zavřít tento kurz? Váš pokrok nebude uložen.',
		passed: 'Hotovo!',
	},
	DA: {
		start: 'Start',
		confirmClosure: 'Er du sikker på, at du vil lukke dette kursus? Din fremgang vil ikke blive gemt.',
		passed: 'Færdig!',
	},
	ES: {
		start: 'Iniciar',
		confirmClosure: '¿Está seguro de que desea cerrar este curso? Su progreso no se guardará.',
		passed: '¡Terminado!',
	},
	FI: {
		start: 'Aloita',
		confirmClosure: 'Haluatko varmasti sulkea tämän kurssin? Edistymisesi ei tallenneta.',
		passed: 'Valmis!',
	},
	HR: {
		start: 'Pokreni',
		confirmClosure: 'Jeste li sigurni da želite zatvoriti ovaj tečaj? Vaš napredak neće biti spremljen.',
		passed: 'Gotovo!',
	},
	HU: {
		start: 'Indítás',
		confirmClosure: 'Biztosan be szeretné zárni ezt a kurzust? A haladás nem lesz mentve.',
		passed: 'Kész!',
	},
	IT: {
		start: 'Avvia',
		confirmClosure: 'Sei sicuro di voler chiudere questo corso? I tuoi progressi non verranno salvati.',
		passed: 'Completato!',
	},
	NO: {
		start: 'Start',
		confirmClosure: 'Er du sikker på at du vil lukke dette kurset? Fremskritten din vil ikke bli lagret.',
		passed: 'Ferdig!',
	},
	PT: {
		start: 'Iniciar',
		confirmClosure: 'Tem certeza de que deseja fechar este curso? Seu progresso não será salvo.',
		passed: 'Concluído!',
	},
	RO: {
		start: 'Începe',
		confirmClosure: 'Sigur doriți să închideți acest curs? Progresul dvs. nu va fi salvat.',
		passed: 'Terminat!',
	},
	RU: {
		start: 'Запустить',
		confirmClosure: 'Вы уверены, что хотите закрыть этот курс? Ваш прогресс не будет сохранен.',
		passed: 'Готово!',
	},
	SK: {
		start: 'Spustiť',
		confirmClosure: 'Ste si istí, že chcete zatvoriť tento kurz? Váš pokrok nebude uložený.',
		passed: 'Hotovo!',
	},
	SI: {
		start: 'Zaženi',
		confirmClosure: 'Ste prepričani, da želite zapreti ta predmet? Vaš napredek ne bo shranjen.',
		passed: 'Končano!',
	},
	SV: {
		start: 'Starta',
		confirmClosure: 'Är du säker på att du vill stänga denna kurs? Din framsteg kommer inte att sparas.',
		passed: 'Klar!',
	},
	TR: {
		start: 'Başlat',
		confirmClosure: 'Bu kursu kapatmak istediğinizden emin misiniz? İlerlemeniz kaydedilmeyecek.',
		passed: 'Tamamlandı!',
	},
	UK: {
		start: 'Запустити',
		confirmClosure: 'Ви впевнені, що хочете закрити цей курс? Ваш прогрес не буде збережено.',
		passed: 'Готово!',
	}
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}